import { useMemo as s, useCallback as a } from "react";
import { useUIContext as i } from "../context/context.js";
const d = ({ label: t, analyticsLabel: c, analyticsProps: l }, e) => {
  const r = s(() => l, [l]), { onClick: o } = i();
  return { handleClick: a(() => {
    if (o) {
      const n = c || t;
      if (n)
        o({
          label: n,
          props: r
        });
      else
        throw new Error("You must provide label or analyticsLabel to the clickable component");
    }
    e && e();
  }, [o, t, c, r, e]) };
};
export {
  d as default
};
//# sourceMappingURL=use-click-handler.js.map
